import { formatDate, formatStatusLabel } from '../helpers';
import ProjectRowActions from '../components/ProjectRowActions';
import { useNavigate } from 'react-router-dom';

const ProjectRow = ({ project, highlight, onDeleted, onStatusChanged }) => {
  const created = formatDate(project?.createdAt);
  const updated = formatDate(project?.updatedAt);
  const navigate = useNavigate();

  const goToProject = () => {
    if (!project?.id) return;
    navigate(`/projects/${project.id}`);
  };

  return (
    <div
      className={`projects-dashboard-list-project
        ${highlight ? 'projects-row-highlight' : ''}
        ${project?.status === 'archived' ? 'projects-row-archived' : ''}
      `}
      role="button"
      tabIndex={0}
      onClick={goToProject}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') goToProject();
      }}
    >
      <div className="projects-dashboard-list-item projects-project-name" title={project?.name ?? ''}>
        {project?.name ?? '—'}
      </div>

      <div className="projects-dashboard-list-item">{created.absolute}</div>

      <div className="projects-dashboard-list-item" title={updated.absolute}>
        {updated.relative}
      </div>

      <div className="projects-dashboard-list-item">
        <span className={`project-status-badge project-status-${project?.status}`}>{formatStatusLabel(project?.status)}</span>
      </div>

      <div className="projects-dashboard-list-item count">{project?.calculationsCount ?? 0}</div>

      {/* Prevent row click when interacting with actions */}
      <div className="projects-dashboard-list-item" onClick={(e) => e.stopPropagation()}>
        <ProjectRowActions
          projectId={project?.id}
          projectName={project?.name}
          projectStatus={project?.status}
          onDeleted={onDeleted}
          onStatusChanged={onStatusChanged}
          onView={() => goToProject()}
        />
      </div>
    </div>
  );
};

export default ProjectRow;
